export default "__VITE_ASSET__0wZEK5nR__"